var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v("組織資料設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationVariableList'
      }
    }
  }, [_vm._v("組織參數管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("編輯")])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('b-card-body', [_c('organization-variable-form', {
    attrs: {
      "disabledKey": true,
      "validationErrors": _vm.validationErrors,
      "organizationVariable": _vm.organizationVariable
    }
  }), _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("儲存")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }